import transitCustom from './transitCustom.json';

export const catalogue = transitCustom.vehicles;
export const catalogueSource = { ...transitCustom.source, checkedAt: transitCustom.checkedAt };
export const catalogueVersion = transitCustom.version;

export const TERMS = {
  rental: [
    { value: 'daily', label: 'Daily rental' },
    { value: 'weekly', label: 'Weekly rental' },
    { value: '28-days', label: '28-day rental' },
  ],
  hire: [
    { value: '3-months', label: '3-month agreement' },
    { value: '6-months', label: '6-month agreement' },
    { value: '9-months', label: '9-month agreement' },
    { value: '12-months', label: '12-month agreement' },
  ],
};

export function getVehicle(idOrSlug) {
  return catalogue.find((vehicle) => vehicle.id === idOrSlug || vehicle.slug === idOrSlug);
}

export function getServiceSelection(selection = {}) {
  const service = selection.service === 'hire' ? 'hire' : 'rental';
  const term = TERMS[service].some((item) => item.value === selection.term)
    ? selection.term : TERMS[service][0].value;
  return { service, term };
}

export function getValidSelection(vehicle, selection = {}) {
  const serviceSelection = getServiceSelection(selection);
  if (!vehicle) return serviceSelection;
  const availableLengths = [...new Set(vehicle.configurations.map((item) => item.length))];
  const length = availableLengths.includes(selection.length) ? selection.length : availableLengths[0];
  const configurations = vehicle.configurations.filter((item) => item.length === length);
  const preferredTrim = configurations.some((item) => item.trim === 'Limited') ? 'Limited' : configurations[0].trim;
  const trim = configurations.some((item) => item.trim === selection.trim) ? selection.trim : preferredTrim;
  return { ...serviceSelection, length, trim };
}

export function getQuoteUrl(vehicle, selection = {}) {
  const resolvedVehicle = typeof vehicle === 'string' ? getVehicle(vehicle) : vehicle;
  const valid = getValidSelection(resolvedVehicle, selection);
  const params = new URLSearchParams();
  if (resolvedVehicle) params.set('vehicle', resolvedVehicle.id);
  Object.entries(valid).forEach(([key, value]) => params.set(key, value));
  return `/request-a-quote?${params.toString()}`;
}

export function getVehiclePath(vehicle, selection = {}) {
  const valid = getValidSelection(vehicle, selection);
  return `/our-vans/ford/transit-custom/${vehicle.slug}?${new URLSearchParams(valid).toString()}`;
}

export function filterVehicles(filters = {}, vehicles = catalogue) {
  return vehicles.filter((vehicle) => (
    (!filters.body || vehicle.body === filters.body)
    && (!filters.powertrain || vehicle.powertrain === filters.powertrain
      || (filters.powertrain === 'electrified' && vehicle.powertrain !== 'diesel'))
    && vehicle.configurations.some((configuration) => (
      (!filters.length || configuration.length === filters.length)
      && (!filters.trim || configuration.trim === filters.trim)
      && (!filters.transmission || configuration.options.some((option) => (
        option.transmission.toLowerCase().includes(filters.transmission.toLowerCase())
      )))
    ))
  ));
}

export const LENGTH_LABELS = { L1: 'L1 · Short wheelbase', L2: 'L2 · Long wheelbase' };
export const BODY_LABELS = { panel: 'Panel van', crew: 'Double Cab-in-Van', multicab: 'MultiCab' };
export const POWERTRAIN_LABELS = { diesel: 'Diesel', phev: 'Plug-in hybrid', electric: 'Fully electric' };
